import { forwardRef, ViewEncapsulation } from '@angular/core';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LsqInputComponent } from '../input/lsq-input.component';

@Component({
    selector: 'lsq-textarea',
    templateUrl: './lsq-textarea.component.html',
    styleUrls: ['./lsq-textarea.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LsqTextAreaComponent),
            multi: true
        }
    ]
})
export class LsqTextAreaComponent extends LsqInputComponent {
    @ViewChild('inputElement') public inputElement: ElementRef;
    @Input() public name = 'textarea';
    @Input() public showError? = true;
    @Input() public resize? = 'none';
    @Input() public rows? = 5;
    @Input() public cols?: number;
    @Input() public labelRows? = 1;
}
